import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoginPromptService } from '../../../core/services/login-prompt.service';

@Component({
  selector: 'app-login-required-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './login-required-modal.component.html',
  styleUrls: ['./login-required-modal.component.scss']
})
export class LoginRequiredModalComponent {
  protected readonly prompt = inject(LoginPromptService);
  private readonly router = inject(Router);

  protected close(): void {
    this.prompt.hide();
  }

  protected goToLogin(): void {
    const returnUrl = this.prompt.returnUrl() ?? this.router.url;
    this.prompt.hide();
    this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
  }

  protected goToRegister(): void {
    const returnUrl = this.prompt.returnUrl() ?? this.router.url;
    this.prompt.hide();
    this.router.navigate(['/auth/register'], { queryParams: { returnUrl } });
  }
}
